import * as React from 'react'

const Title: React.FC<React.PropsWithChildren> = ({ children }) => (
	<h2 className="text-xs font-bold tracking-widest uppercase md:text-sm text-brand-gray-400">{children}</h2>
)

export default Title
